import { reduce } from "et3-type-guards";

import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import { getPermissionIDRequired } from "../../../helpers/et3-has-permission";
import getCorePersonalStore from "../../../stores/core/core-personal-store";

import { TSubMenuDropDownProps } from "../../../Types";
import SubMenuDropDownItem from "./SubMenuDropDownItem";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ET3Div from "../../../core/et3-div";
import {
  SIDE_BAR_MENU_PADDING_X,
  SIDE_BAR_RAIL_BORDER,
  SIDE_BAR_RAIL_INSET,
  SIDE_BAR_SUB_MENU_WIDTH
} from "../side-bar-constants";

const SubMenuDropDown = withLiteObserverAndTheme<TSubMenuDropDownProps>(
  (props) => {
    const { options, theme } = props;
    const { colors, unitX } = theme;
    const userPermissions = getCorePersonalStore().userPermissions.get();
    const items = options.map((option) => {
      const name = reduce(() => option.name, "");
      const pageName = reduce(() => option.pageName, "");
      const pageSubName = reduce(() => option.pageSubName, "");
      const visible = reduce(
        () =>
          userPermissions.indexOf(getPermissionIDRequired(name)) > -1 &&
          option.visibility,
        false
      );
      const isSelected = getCoreHistoryStore().getPageName() === pageName;
      const isSubTabSelected =
        getCoreHistoryStore().getPageSubName() === pageSubName;
      return (
        <SubMenuDropDownItem
          isSelected={isSelected && isSubTabSelected}
          visible={visible}
          option={option}
          key={option.name}
        />
      );
    });

    return (
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={SIDE_BAR_SUB_MENU_WIDTH}
        height={0}
        fDirection="column"
        alignItems="stretch"
        justifyContent="center"
        color={colors.all.transparent}
        style={{
          boxSizing: "border-box",
          flexShrink: 0,
          borderLeft: SIDE_BAR_RAIL_BORDER,
          marginLeft: SIDE_BAR_RAIL_INSET * unitX,
          paddingLeft: SIDE_BAR_MENU_PADDING_X * unitX
        }}
        onClick={() => {}}
      >
        {items}
      </ET3Div>
    );
  }
);
export default SubMenuDropDown;
